module.exports = __webpack_public_path__ + "img/3min_exam.ca51b7e8.png";